'use client';

import '@/slw/shared/global/client';
import '@/slw/shared/lib/error-handler'; // Initialize error handler
import { PropsWithChildren, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

import { ModalContainer } from '@/slw/shared/lib/modal/modal.container';
import { SessionExpiredProvider, useSessionExpired } from '@/slw/shared/contexts/session-expired-context';
import { setSessionExpiredHandler } from '@/slw/shared/lib/session-expired.service';

const SessionExpiredHandler = () => {
  const { showSessionExpiredDialog } = useSessionExpired();

  useEffect(() => {
    setSessionExpiredHandler(showSessionExpiredDialog);
  }, [showSessionExpiredDialog]);

  return null;
};

export const ClientProvider = ({ children }: PropsWithChildren) => {
  return (
    <SessionExpiredProvider>
      <SessionExpiredHandler />
      {children}
      <ModalContainer />
      <Toaster />
    </SessionExpiredProvider>
  );
};
